import { CookieConsent } from '@lalalilo/front-utils'
import { useTranslation } from 'react-i18next'
import { useIsP2IAPage } from '../../compagnon/routers/useIsP2IA'
import { useIsUserInFrance } from '../../i18n/france'
import { useSharedTrackers } from './useSharedTrackers'

export const SharedCookieConsent = () => {
  const isUserInFrance = useIsUserInFrance()
  const { trackersParameters } = useSharedTrackers()
  const isP2IA = useIsP2IAPage()
  const [t] = useTranslation('cookies_disclosure')
  return (
    <CookieConsent
      isUserInFrance={isUserInFrance}
      localizedStrings={{
        cookieBox: {
          regionAriaLabel: t('region_aria_label'),
          closeButtonAltText: t('close_button_alt'),
        },
        simpleCookies: {
          preTitle: t('pre_title'),
          title: t('title'),
          description: t('presentation'),
          choose: t('choose'),
          accept: t('accept'),
        },
        detailedCookies: {
          functionalCookies: t('functional_cookies'),
          functionalCookiesDescription: t('functional_cookies_description'),
          performanceCookies: t('performance_cookies'),
          performanceCookiesDescription: t('performance_cookies_description'),
          save: t('save'),
          switchStrings: {
            on: t('aria:on'),
            off: t('aria:off'),
          },
        },
        onlyNecessary: {
          preTitle: t('pre_title'),
          title: t('title'),
          description: t('p2ia_presentation'),
          acknowledge: t('acknowledge'),
        },
      }}
      isP2iaPage={isP2IA}
      trackersParameters={trackersParameters}
    />
  )
}
